export default __webpack_public_path__ + "static/media/cii.9a22a667.jpg";